<template>
  <div class="micropoint">
    <div class="pageTop" v-if="swipeList.length > 0">
      <van-swipe :autoplay="10000" indicator-color="white">
        <van-swipe-item v-for="(image, index) in swipeList" :key="index">
          <img class="newImg" v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="store_bg_con">
      <div class="store_info_con">
        <!-- 视频图片 -->
        <div class="goods_img_con" v-if="vpnInfo.storeImg">
          <img :src="vpnInfo.storeImg" alt="" />
        </div>

        <!-- 内容 -->
        <div class="goods_info_con">
          <div>
            <!-- 名称 -->
            <div class="name_con">
              {{ vpnInfo.Name }}
            </div>
            <div class="time_con">
              营业时间：{{ vpnInfo.BusinessStartTime }}-{{
                vpnInfo.BusinessEndTime
              }}
            </div>
          </div>

          <div>
            <div class="store_phone_con" @click="phone">
              <div>
                <span class="store_text_con">{{ vpnInfo.Phone }}</span>
              </div>

              <div>
                <i class="iconfont icon-dianhua" />
              </div>
            </div>
            <!-- <div class="store_phone_con">
              <div @click="toAddress(vpnInfo)">
                
                <i  class="iconfont icon-dingwei" />
                <span
                  class="store_text_con"
                 
                  >{{ vpnInfo.Address }}</span
                >
              </div>

              <div>
                <i class="el-icon-arrow-right" />
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="micropointContainer">
      <div class="micropointSideNavbar" ref="menu">
        <div class="sideNavbar">
          <p
            v-for="(item, index) in catalogList"
            :key="index"
            :class="index === catalog ? 'active' : ''"
            @click="catalogStyle(index)"
          >
            <a>{{ item.name }}</a>
            <!-- <van-badge
              color="#AC8D5F"
              v-if="item.num > 0"
              :content="item.num"
              max="99"
            /> -->
          </p>
        </div>
      </div>
      <div class="micropointGoodsList" ref="menuList">
        <ul class="goodsList">
          <li v-for="itemd in goodsList" :key="itemd.Id">
            <!-- <div class="goodsImg">
                <img
                  class="full_img"
                  v-lazy="itemd.PicUrl ? itemd.PicUrl : $root.defaultImg"
                  alt=""
                />
              </div> -->
            <div class="goodsDetails">
              <div class="goodsName">
                {{ itemd.ProductName }}
              </div>

              <div class="saleNum" v-if="itemd.Duration">
                {{ itemd.Duration }}分钟
              </div>

              <div class="lastLine">
                <div class="price">
                  <a>￥{{ itemd.Price }}</a>
                </div>
                <div class="changeNumBar">
                  <van-button
                    color="#CCA567"
                    size="small"
                    @click="handleBookProject(itemd)"
                    >预约</van-button
                  >
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Search, Badge, Popup, Dialog, Toast } from "vant";
import BScroll from "better-scroll";
import { handleSessionStorage, handleTimeLocalStorage } from "@/utils";
import { getProductList, getBookRegisterConfig } from "@/api/bookRegister";
export default {
  name: "BookRegister",
  props: {},
  data() {
    return {
      catalog: 0,
      goodsList: [],
      catalogList: [],
      isInitScroll: true,
      hackMarginBottom: 0,
      vpnInfo: {},
      allVpnList: [],
      configObj: {},
      swipeList: [],
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      const vpnItem = this.allVpnList.find((v) => {
        return v.Id === val;
      });
      this.vpnInfo = vpnItem;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const _this = this;
      if (localStorage.getItem("allStoreList")) {
        handleSetVpn();
      } else {
        window.addEventListener("setItem", () => {
          console.log("设置777777777777777777777777777");
          handleSetVpn();
        });
      }
      function handleSetVpn() {
        _this.allVpnList = JSON.parse(localStorage.getItem("allStoreList"));
        let getVpnId = _this.$store.state.vpnId;
        const vpnItem = _this.allVpnList.find((v) => {
          return v.Id === getVpnId;
        });
        if (getVpnId && vpnItem) {
          _this.vpnInfo = vpnItem;
        } else {
          _this.vpnInfo = _this.allVpnList[0];
        }
        _this.handleGetConfig();
        _this.getGoodsList();
      }
    },
    phone() {
      $pub.toTel(this.vpnInfo.Phone);
    },
    handleGetConfig() {
      getBookRegisterConfig({ VpnId: this.vpnInfo.Id }).then((res) => {
        this.configObj = res;
        if (res.BackgroundStyle) {
          const swipeArr = JSON.parse(res.BackgroundStyle);
          this.swipeList = swipeArr.map(
            (item) => "http://saas-store.oss-cn-beijing.aliyuncs.com/" + item
          );
        }
        // res.BookingNumberOfPeople = 1;
        handleTimeLocalStorage.set("bookConfig", res);
      });
    },
    getGoodsList(flag) {
      this.catalogList = [];
      this.goodsList = [];
      getProductList({ VpnId: this.vpnInfo.Id }).then((res) => {
        res.forEach((item, index) => {
          // const shortCutItem = item.ShortCutItem
          const itemGoodsList = item.Items;
          const catalog = {
            id: item.GoodsCatalogId,
            name: item.GoodsCatalog,
            list: itemGoodsList,
            // num: 0,
          };
          // if (itemGoodsList && itemGoodsList.length > 0) {
          //   itemGoodsList.forEach((goodsItem) => {
          //     goodsItem.num = 0;
          //   });
          //   this.catalogList.push(catalog);
          //   this.goodsList.push(itemGoodsList);
          // }
          this.catalogList.push(catalog);
        });
        this.catalogStyle(0);

        this.$nextTick(() => {
          if (this.isInitScroll) {
            this.scrollInit(); // 多次初始化滚动事件会导致，数量加减的click事件重复执行
            this.isInitScroll = false;
          }
        });
      });
    },
    scrollInit() {
      this.menuScroll = new BScroll(this.$refs.menu, {
        click: true,
      });
      this.goodsScroll = new BScroll(this.$refs.menuList, {
        click: true,
        probeType: 3,
      });
      // this.scrollType = true;
    },
    // 点击左侧分类
    catalogStyle(index) {
      this.catalog = index;
      console.log(this.catalogList);
      this.goodsList = this.catalogList[this.catalog].list;
      if (this.goodsScroll) {
        this.$nextTick(() => {
          this.goodsScroll.refresh();
        });
      }
    },
    handleBookProject(item) {
      handleTimeLocalStorage.set("pointProject", {
        Name: item.ProductName,
        Id: item.Id,
      });
      this.$router.push({
        name: this.configObj.JsStatusId == 1 ? "SelectJishi" : "SelectPeriod",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.micropoint {
  // line-height: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // background: #fff;
  .pageTop {
    // margin-bottom: 15px;
    height: 300px;
    // padding: 24px 32px 0;
    img {
      width: 100%;
      height: 300px;
      // border-radius: 16px;
    }
  }
  .store_bg_con {
    background-color: #fff;
    padding: 28px 32px;
    margin-bottom: 2px;
  }
  .store_info_con {
    background: #f8f8f8;
    padding: 28px 24px;
    display: flex;
    border-radius: 13px;
    .goods_img_con {
      width: 128px;
      height: 128px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods_info_con {
      flex: 1;
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name_con {
        margin-bottom: 5px;
        color: #333;
      }
      .time_con {
        color: #999;
        font-size: 24px;
      }

      .store_phone_con {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        .iconfont {
          font-size: 28px;
        }
        img {
          width: 30px;
          height: 30px;
          vertical-align: -4px;
        }
      }
    }
  }
  .micropointContainer {
    position: relative;
    width: 100%;
    flex: 1;
    overflow: hidden;
    background: #fff;
    .micropointSideNavbar {
      position: absolute;
      top: 0;
      left: 0;
      width: 164px;
      height: 100%;
      background: #f5f5f5;
      box-sizing: border-box;
      .sideNavbar {
        // padding-bottom: 96px;
        .van-badge {
          position: absolute;
          right: 5px;
          top: 5px;
        }
      }

      p {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 104px;
        text-align: center;
        box-sizing: border-box;

        a {
          display: flex;
          display: -webkit-flex;
          align-content: center;
          justify-content: center;
          flex-flow: column wrap;
          width: 100%;
          height: 100%;
          font-size: 26px;
          line-height: 36px;
          color: #333;
        }
      }
      .active {
        &::before {
          content: "";
          width: 6px;
          height: 30px;
          background: #333;
          border-radius: 3px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        > a {
          // color: #333 !important;
          font-weight: bold;
          background: #fff;
        }
      }
    }
    .micropointGoodsList {
      position: absolute;
      top: 0;
      right: 0;
      width: 586px;
      height: 100%;
      .goodsList {
        box-sizing: border-box;
        width: 100%;

        > li {
          position: relative;
          display: -webkit-flex;
          display: flex;
          display: -webkit-flex;
          width: 100%;
          box-sizing: border-box;
          padding: 16px 24px;
          // .goodsImg {
          //   flex: none;
          //   z-index: 2;
          //   width: 136px;
          //   height: 136px;
          //   border-radius: 16px;
          //   overflow: hidden;
          // }
          > .goodsDetails {
            position: relative;
            flex: 1;
            -webkit-flex: 1;
            box-sizing: border-box;
            padding-left: 15px;
            .goodsName {
              margin-bottom: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 30px;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
              line-height: 42px;
            }
            .saleNum {
              margin-bottom: 8px;
              font-size: 24px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 30px;
            }
            .label_list_con {
              display: flex;
              flex-wrap: wrap;
              li {
                padding: 5px 6px;
                color: #ff6010;
                background: #ffece3;
                border-radius: 4px;
                font-size: 22px;
                margin-right: 8px;
              }
            }
            .price {
              line-height: 28px;
              font-size: 26px;
              font-weight: 600;
              font-family: "Roboto-Bold";
              color: #807347;

              > i {
                font-style: normal;
                font-size: 24px;
              }
            }
            .lastLine {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 60px;
              box-sizing: border-box;
              .changeNumBar {
                position: relative;
                .van-badge {
                  position: absolute;
                  right: -8px;
                  top: -8px;
                }
              }
            }
            .sellOut,
            .disableSaleRemark {
              width: 100%;
              text-overflow: ellipsis;
              overflow-x: hidden;
              white-space: nowrap;
              line-height: 44px;
              font-size: 28px;
              text-align: right;
              color: #fbab55;
            }
          }
        }

        li:not(:last-child) {
          border-bottom: 2px solid #f7f7f7;
        }
      }
    }
  }
}
</style>
